/// <amd-module name="VSSUI/Components/Header/HeaderTitleArea" />
import * as React from "react";

import { IHeaderTitleAreaProps } from "./Header.Props";

import { css } from "VSSUI/Util";

export class HeaderTitleArea extends React.Component<IHeaderTitleAreaProps> {
    public render() {
        return <div className={css(this.props.className, "bolt-header-title-area flex-column flex-grow scroll-hidden")}>{this.props.children}</div>;
    }
}
